import { ChainList } from '../Components/ChainList';
import { FeaturesIntroSection } from '../Components/FeaturesIntroSection';
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import IntroSection from '../Components/IntroSection';
// import { LoginForm } from '../Components/LoginForm';
// import { ProfileForm } from '../Components/ProfileForm';
import Content from '../Views/MainContent';

export default function Profile() {
  return (
    <>
      <Header />
      {/* <ProfileForm /> */}
      {/* <Footer /> */}
    </>
  );
}
